export default {
    "deposit": "Phiếu cọc",
    "create": "Tạo",
    "update": "Chỉnh sửa",
    "delete": "Hủy",
    "receipt_collected": "Phiếu thu cô Gấm",
    "check_in": "Phiếu nhận phòng",
    "receipt_room": "Phiếu thu tiền phòng",
    "transfer_deposit": "Chuyển cọc",
    "check_out": "Trả phòng",
    "receipt_change": "Phiếu thay đổi thông tin",
    "increase_room": "Tăng giá phòng",
    "payment": "Bảng tính tiền phòng",
    "disbursement": "Phiếu chi",
    "commission": "Dẫn phòng",
    "loan": "Nợ",
    "receipt_other": "Phiếu thu khác"
}